import React, { useState } from "react";
import Search from "../../images/search.png";
import Logo from "../../images/logo.png";
import Cal from "../../images/calender.png";
import Bell from "../../images/bell.png";
import Ellipse from "../../images/Ellipse.png";
import Vector from "../../images/Vector.png";
import Arrow from "../../images/arrow.png";
import UserProfile from "../UserProfile/UserProfile.js";
import "./header.css";

const Header = () => {
  //hook used for state
  const [showprofile, setShowProfile] = useState(false);

  //function to set the state using hook
  const toggle = () => setShowProfile(!showprofile);

  return (
    <header className="feed-header">
      <div className="header-left">
        <img src={Logo} alt="" />
        <span>Penn Hospital</span>
        <div className="header-search">
          <img src={Search} alt="" />
          <input id="header_search_inp" type="text" placeholder="Search hospitals,doctors.." />
        </div>
      </div>
      <div className="header-right">
        <img src={Cal} alt="" />
        <img src={Vector} alt="" />
        <img src={Bell} alt="" />
        <img src={Ellipse} alt="" />
        <div className="log-div">
          <div className="d-flex login-det">
            <h6>Ted Russell</h6>
            <img onClick={toggle} src={Arrow} alt="" />
          </div>
          <p className="text-muted">Doctor</p>
        </div>
        {showprofile && <UserProfile />}
      </div>
    </header>
  );
};

export default Header;
